import { Component, OnInit } from '@angular/core';
import { ScrBaseComponent } from 'src/app/components/base.component';
import { Account } from 'src/app/models/account.model';
import { AccountService } from 'src/app/services/account.service';
import { ShortCodesRole } from '../../../../models/constants';

@Component({
  selector: 'app-account-summary',
  templateUrl: './account-summary.component.html',
  styleUrls: ['./account-summary.component.scss']
})
export class AccountSummaryComponent extends ScrBaseComponent implements OnInit {
  public account: Account = new Account();
  public leasedCodeCount?: number;

  public monthlyBillingStatus?: string;
  public programStatusText?: string;
  public managingAccountCompanyName?: string;
  public displayedProgramType?: string;
  public billingAddressCombined?: string;
  public addressCombined?: string;
  CognitoGroup: typeof ShortCodesRole = ShortCodesRole;

  constructor(private accountService: AccountService) { super(); }

  ngOnInit(): void {
    this.observe(this.accountService.getAccountWithSummary(), rsp => {
      this.account = rsp.accountSummary.account;
      this.leasedCodeCount = rsp.accountSummary.leasedCodeCount;
      this.monthlyBillingStatus = rsp.accountSummary.monthlyBillingStatus || "";
      this.displayedProgramType = this.account.programType;
      this.managingAccountCompanyName = rsp.accountSummary.managingAccountCompanyName;
      if (this.account.state) {
        this.addressCombined = `${this.account.city}, ${this.account.state} ${this.account.zip ?? ''}`;
      } else {
        this.addressCombined = `${this.account.city}`;
      }
      if (this.account.billingState) {
        this.billingAddressCombined = `${this.account.billingCity}, ${this.account.billingState} ${this.account.billingZip ?? ''}`;
      } else {
        this.billingAddressCombined = `${this.account.billingCity}`;
      }
      if (this.account.programTypeReviewStatus?.toLowerCase() !== 'accepted' && this.account.programTypeReviewStatus?.toLowerCase() !== 'rejected') {
        if (this.account.programTypeRequested?.toLowerCase() === 'government') {
          this.programStatusText = '(pending review of Government Agency application)';
        } else if (this.account.programTypeRequested?.toLowerCase() === 'charity') {
          this.programStatusText = '(pending review of Charitable Organization application)';
        } else if (this.account.programTypeRequested?.toLowerCase() === 'smb') {
        this.programStatusText = '(pending review of Small/Medium Business application)';
      }
    } else if (this.account.programTypeReviewStatus?.toLowerCase() === 'accepted') {
        switch (this.account.programType?.toLowerCase()) {
          case 'charity':
            this.displayedProgramType = 'Charitable Organization';
            break;
          case 'government':
            this.displayedProgramType = 'Government Agency';
            break;
          case 'smb':
            this.displayedProgramType = 'Small/Medium Business';
            break;
          default:
            this.displayedProgramType = this.account.programType;
            break;
        }
      }
      return false; // don't display success.
    });
  }
}
